import {
  WSGrid,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import { queriesPayers } from "@query";
import React from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { useQueryPayerEngagement } from "../../../query/payerEngagements/queries/useQueryPayerEngagement";
import { useQueryPayerEngagementsList } from "../../../query/payerEngagements/queries/useQueryPayerEngagementsList";
import { WSQueries } from "../../../query/WSQuery";
import { ResourceHistory } from "../../../shared/components/ResourceHistory";
import { selectorPayerDisplayName } from "../../../shared/selectors/selectorPayerDisplayName";
import { selectorPayerPayeeEngagementName } from "../../Payees/selectors/selectorPayerPayeeEngagementName";
import { usePayerEngagementHistoryResources } from "../hooks/usePayerEngagementHistoryResources";
import { getPayerEngagementUrl, PAYERS_PATH } from "../paths";

export const RoutePayerEngagementHistory: React.FC = () => {
  const history = useHistory();
  const match = useRouteMatch<{ engagementId: string; payerId: string }>();
  const payerId = match.params.payerId;
  const engagementId = match.params.engagementId;

  const queryEngagement = useQueryPayerEngagement(payerId, engagementId);
  const queryPayer = queriesPayers.getPayer.useQuery(
    { payerId },
    { retry: false }
  );
  const queryPayerEngagements = useQueryPayerEngagementsList(payerId);

  const historyResources = usePayerEngagementHistoryResources(engagementId);

  return (
    <WSPage>
      <WSQueries
        queries={{ queryEngagement, queryPayer, queryPayerEngagements }}
      >
        {({ queryEngagementData, queryPayerData }) => {
          const engagementName = selectorPayerPayeeEngagementName(
            queryEngagementData,
            true
          );

          const payerName = selectorPayerDisplayName(queryPayerData);

          return (
            <>
              <WSPageToolbar
                title="Assignment history"
                breadcrumbs={[
                  {
                    label: "Clients",
                    onClick: () => {
                      history.push(PAYERS_PATH);
                    }
                  },
                  {
                    label: payerName,
                    onClick: () => {
                      history.push(PAYERS_PATH + `/${payerId}`);
                    }
                  },
                  {
                    label: engagementName || "Assignment",
                    onClick: () => {
                      history.push(
                        getPayerEngagementUrl(payerId, engagementId)
                      );
                    }
                  },
                  {
                    label: "Assignment history"
                  }
                ]}
              />

              <WSGrid>
                <WSGrid.Item span={{ l: "8" }}>
                  <WSList gap="2XL">
                    <ResourceHistory resources={historyResources} />
                  </WSList>
                </WSGrid.Item>
              </WSGrid>
            </>
          );
        }}
      </WSQueries>
    </WSPage>
  );
};
